var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"caption font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t(_vm.field))+" "),(_vm.isRequired)?_c('span',{staticClass:"secondary--text"},[_vm._v(" "+_vm._s(_vm.$t('commonLabels.required'))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }